export const NPS_STATUS_VALUES = ['open', 'assigned', 'resolved', 'closed'];

export const NPS_STATUS_OPTIONS = [
  { value: 'open', label: 'Open' },
  { value: 'assigned', label: 'Assigned' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'closed', label: 'Closed' },
];

export const DEFAULT_NPS_STATUS_FILTER = ['open'];

export const NPS_ASSIGN_TEAMS = ['IT', 'Operations', 'Sales', 'Product', 'Finance'];

export function getNpsItemStatus(item) {
  const status = item?.status;
  if (NPS_STATUS_VALUES.includes(status)) return status;
  return 'open';
}

export function itemMatchesNpsStatusFilter(item, statuses) {
  if (!statuses || statuses.length === 0) return true;
  return statuses.includes(getNpsItemStatus(item));
}

export function isDefaultNpsStatusFilter(statuses) {
  return statuses?.length === 1 && statuses[0] === 'open';
}

export function showNpsResolutionUi(item) {
  const status = getNpsItemStatus(item);
  return status === 'resolved' || status === 'closed';
}

export function canNpsQueueActions(item) {
  const status = getNpsItemStatus(item);
  return status === 'open' || status === 'assigned';
}

export function canNpsReopen(item) {
  return getNpsItemStatus(item) === 'resolved';
}

/** Leadership sign-off: resolved → closed */
export function canNpsLeadershipClose(item) {
  return getNpsItemStatus(item) === 'resolved';
}
